require('./angular-busy');
module.exports = 'cgBusy';


/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-busy/dist/index.js
 ** module id = 354
 ** module chunks = 0
 **/